const toggletipButton = "_toggletipButton_avoe4_3";
const toggletipTrigger = "_toggletipTrigger_avoe4_22";
const toggletipIcon = "_toggletipIcon_avoe4_37";
const toggletipTriggerIconHidden = "_toggletipTriggerIconHidden_avoe4_42";
const toggletipPopover = "_toggletipPopover_avoe4_48";
const toggletipArrow = "_toggletipArrow_avoe4_61";
const styles = {
  toggletipButton,
  toggletipTrigger,
  toggletipIcon,
  toggletipTriggerIconHidden,
  toggletipPopover,
  toggletipArrow,
  "toggletip-default-icon": "_toggletip-default-icon_avoe4_67",
  "toggletip-default-active": "_toggletip-default-active_avoe4_75",
  "toggletip-default-text": "_toggletip-default-text_avoe4_83",
  "toggletip-inverted-icon": "_toggletip-inverted-icon_avoe4_89",
  "toggletip-inverted-active": "_toggletip-inverted-active_avoe4_97",
  "toggletip-inverted-text": "_toggletip-inverted-text_avoe4_105"
};
export {
  styles as s
};
